import { ToastContainer } from "../../components/Common";
import { useParams } from "react-router-dom";
import useAuthUser from "../../common/hooks/authUser";
import QuoteFormProvider from "./context";
import QuoteCreatePage from "./page";

const QuoteCreatePageWrapper = () => {
    const { id: paramsId } = useParams();
    const id = Number(paramsId || 0);

    const { user } = useAuthUser();

    if (isNaN(id)) return "Incorrect Quote ID";

    return (
        <>
            <div className="page-content">
                <QuoteFormProvider>
                    <QuoteCreatePage
                        id={id}
                        userId={user.id}
                    />
                </QuoteFormProvider>
            </div>
            <ToastContainer />
        </>
    );
};

export default QuoteCreatePageWrapper;
